export enum StateRoutes {
  BuildMany = 'build-many',
  BuildManyClosedLoop = 'build-many-closed-loop',
  BuildMs = 'build-ms',
  DetectManual = 'detect-manual',
}
